// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
.k-animation-container {
  z-index: 20000 !important;
}

.osjs-panel {
  display: flex;
  height: 2.8em;
  min-height: 2.8em;
  align-items: center;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  line-height: normal;
}
.osjs-panel[data-ontop=true] {
  /* Begin Oxzion customization. */
  /* z-index: 9995; */
  z-index: 9995 !important;
  /* End Oxzion customization. */
}
.osjs-panel > .osjs-panel-item {
  min-height: 1em;
  position: relative;
  box-sizing: border-box;
  padding: 0.6666666667em;
  height: 100%;
}
.osjs-panel .osjs-panel-item--icon {
  display: flex;
  align-items: center;
  margin: 0px 7px;
}
.osjs-panel .osjs-panel-item--icon > i {
  height: 1em;
  margin-right: 0.5em;
}
.osjs-panel .osjs-panel-item--icon > i > span {
  font-size: 14px;
}
.osjs-panel .osjs-panel-item--icon .close-icon {
  margin: 0.1em 0px 0px 0.5em;
  height: 18px;
  width: 18px;
  align-items: center;
  display: flex;
  justify-content: center;
}
.osjs-panel .osjs-panel-item--icon .close-icon:hover {
  background-color: #0097C2;
  border-radius: 50%;
}

.footer-CR {
  display: flex;
  min-height: 2.05em;
  align-items: center;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  right: 0;
  line-height: normal;
  bottom: 0 !important;
  flex-direction: row-reverse !important;
  background-color: #275362 !important;
  z-index: 18;
}

.footer-CR .coppyRight {
  color: #fff;
}

.osjs-root[data-dir=rtl] .osjs-panel > .osjs-panel-item:not(:last-child) {
  margin-right: 0;
  margin-left: 1em;
}

.profile {
  height: calc(100% - 3.5em);
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
  flex-direction: column;
  width: 0;
  position: absolute;
  right: 0;
  top: 0;
  margin-top: 3.5em;
  margin-bottom: 3.5em;
  background-color: rgb(0, 0, 1);
  transition: 0.5s;
}

.profile-visible {
  width: 300px;
  z-index: 16777271;
  padding-left: 7px;
}

.appmenu {
  height: calc(100% - 4.5em);
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
  flex-direction: column;
  width: 0;
  position: absolute;
  top: 0;
  margin-top: 2.5em !important;
  margin-bottom: 3.5em;
  background-color: rgb(0, 0, 1);
  transition: 0.5s;
}

.appmenu-visible {
  width: 300px;
  z-index: 9994;
}

/* Position and style the close button (top right corner) */
.appmenu .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 48px;
  margin-left: 50px;
}

.appmenu .app-bar {
  flex-grow: 1;
  order: 4;
  padding-right: 0;
  box-sizing: border-box;
  position: relative;
  align-self: auto;
  padding-bottom: 0;
  padding-left: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.appmenu .app-bar::-webkit-scrollbar {
  width: 6px;
}

.appmenu .app-bar .category {
  box-sizing: border-box;
  order: 0;
  min-height: 48px;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 10px;
}

.appmenu .app-bar .applist {
  display: flex;
  flex-direction: column;
}

.appmenu .app-bar .category .caption {
  box-sizing: border-box;
  text-align: left;
  padding-left: 0px;
  margin-bottom: 5px;
  margin-top: 5px;
  align-self: stretch;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.85);
}

.appmenu .app-bar .app {
  margin: 5px 10px;
  flex-direction: unset;
  min-height: 48px;
  max-width: unset;
  display: flex;
}

.appmenu .app-bar .app .icon {
  box-sizing: border-box;
  position: relative;
  max-width: 48px;
  min-width: 48px;
  font-size: 25px;
  height: 48px;
  color: #fff !important;
  height: 48px;
  line-height: 48px !important;
  text-align: center;
  background-size: 45px;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: inherit !important;
}

.appmenu .app-bar .app .appcaption {
  box-sizing: border-box;
  color: #275362;
  font-size: 16px;
  line-height: 48px;
  display: inline-block;
  padding-left: 14px;
  width: 100%;
  overflow: hidden;
}

.appmenu .app-search-div {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  border: 0px solid transparent;
  order: 3;
  flex: 0 1 auto;
  align-self: auto;
  flex-shrink: 0;
  width: 100%;
  overflow: hidden;
}

.appmenu .app-search-bar-div {
  width: 100%;
  transition: all 0.5s cubic-bezier(0, 0.105, 0.035, 1.57);
  overflow: hidden;
  background: white !important;
  position: relative;
  transition: all 0.3s ease-in-out;
  padding: 0 15px;
  display: flex;
}

.appmenu .app-search-div input {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: none;
  width: 100%;
  height: 48px;
  position: relative;
  top: 0;
  left: 0;
  background: 0 0;
  box-sizing: border-box;
  border: 0;
  outline: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #265160;
  padding: 0 10px;
  transition: all 0.3s cubic-bezier(0.39, 0.58, 0.57, 1), padding 0s;
  transition-delay: 0.3s;
}

.appmenu .app-bar .applist .app i {
  background-repeat: no-repeat;
  box-sizing: border-box;
  position: relative;
  max-width: 48px;
  min-width: 48px;
  font-size: 25px;
  display: flex;
  color: #265160 !important;
  height: 48px;
  line-height: 48px !important;
  text-align: center;
  background-size: 30px;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: inherit !important;
}

.appmenu .app-bar .app:hover {
  background: rgba(255, 255, 255, 0.3019607843);
  transition: all 200ms ease-in;
  background-size: cover !important;
}

.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach {
  height: 100%;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .panel-active {
  display: block !important;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-bar-container {
  display: flex;
  color: white;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-bar-container i {
  font-size: 19px;
  margin-left: 5px;
  cursor: pointer;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-bar-container .global-search-bar {
  width: 320px;
  display: none;
  z-index: 30000 !important;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-bar-container .global-search-bar .input-search-icon {
  font-size: 11px;
  position: absolute;
  left: 10px;
  top: 16px !important;
  color: #314961;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-bar-container .global-search-bar .input-clear-icon {
  font-size: 12px;
  position: absolute;
  right: 15px;
  top: 16px !important;
  color: #314961;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-bar-container .global-search-bar .search-bar {
  width: 100%;
  color: #000000;
  height: 30px;
  font-size: 13px;
  background-color: #EAEFF2;
  border-radius: 50px;
  outline: none;
  border: 1px solid #2375F5;
  padding: 0px 38px;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .search-icon {
  height: 30px;
  display: flex;
  width: 30px;
  padding: 0px;
  align-items: center;
  justify-content: center;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .search-icon-inactive {
  display: none !important;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel {
  display: none;
  z-index: 30000 !important;
  position: fixed;
  width: 24em;
  top: 43px;
  color: #000000;
  padding: 15px;
  border-radius: 5px;
  min-height: 150px;
  background-color: #EAEFF2;
  animation: 1s ease-out 0s 1 slideInFromLeft;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .search-filters {
  padding: 0px 0px 0px 5px;
  width: 100%;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .search-filters .filter-option-container .filter-option {
  display: inline-grid;
  text-align: center;
  width: 31%;
  padding: 3px 11px;
  border-width: 2px;
  border-style: solid;
  border-color: rgb(7, 119, 253);
  border-image: initial;
  margin: 10px 3px;
  border-radius: 3px;
  color: #0777FD;
  background-color: #F6F8FA;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .search-filters .filter-option-container .filter-option .option-name {
  font-size: 12px;
  font-weight: 500;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .search-filters .filter-option-container .focus {
  color: #FFFFFF;
  background-color: #314961;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .search-filters .filter-option-container .filter-option:hover {
  background-color: #314961;
  color: #FFFFFF;
  cursor: pointer;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .search-filters .recent-searched-container .recent-searched .label-focus {
  color: #000000 !important;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .search-filters .recent-searched-container .recent-searched .data-name {
  font-size: 12px;
  display: inline-grid;
  font-weight: 600;
  text-align: left;
  color: #0777FD;
  margin: 6px 12px 6px 0px;
  cursor: pointer;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .search-filters .recent-searched-container .margin-top {
  margin-top: 10px;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .error-msg {
  color: #F93F3F;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 10px;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .search-label {
  color: #000000;
  font-size: 13px;
  font-weight: 600;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .search-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.osjs-panel-item[data-name=globalSearch] .osjs-panel-global-serach .global-search-panel .search-button-container .search-button {
  color: #0777FD;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
}

.osjs-panel-item[data-name=myHome] {
  display: flex;
  align-items: center;
}
.osjs-panel-item[data-name=myHome] .osjs-panel-my-home {
  height: 70%;
  align-items: center;
  display: flex;
  padding: 0px 12px;
  border-radius: 10px;
}
.osjs-panel-item[data-name=myHome] .osjs-panel-my-home .icon {
  font-size: 16px;
  color: #ffffff;
}
.osjs-panel-item[data-name=myHome] .panel-active {
  background-color: #007698;
}
.osjs-panel-item[data-name=myHome] .osjs-panel-my-home:hover {
  background-color: #007698;
  cursor: pointer;
}

.osjs-panel-item[data-name=notificationCenter] {
  @import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");
  align-items: center;
  margin: 0px 0px 0px 8px !important;
}
.osjs-panel-item[data-name=notificationCenter] .osjs-panel-notificationCenter {
  display: flex;
  height: 100%;
  flex-direction: row;
  font-size: 15px;
  color: white;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  position: relative;
}
.osjs-panel-item[data-name=notificationCenter] .osjs-panel-notificationCenter i {
  font-size: 20px;
}
.osjs-panel-item[data-name=notificationCenter] .osjs-panel-notificationCenter .notificationCenter-badge {
  border-radius: 50%;
  background-color: #F93F3F;
  font-size: 12px;
  text-align: center;
  min-width: 19px;
  position: relative;
  line-height: 14px;
  bottom: 7px;
  padding: 2px;
  right: 6px;
}
@keyframes slideInFromLeft {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .panel-active {
  display: block !important;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel {
  display: none;
  z-index: 30000 !important;
  position: fixed;
  width: 22em;
  top: 42px;
  right: 4em;
  height: 58vh;
  background-color: #ffffff;
  border-radius: 5px;
  animation: 1s ease-out 0s 1 slideInFromLeft;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .tasks-completed {
  height: calc(58vh - 82px);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .dropdown-container {
  background-color: #416080;
  font-weight: 600;
  height: 40px;
  display: flex;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .dropdown-container .dropdown-info {
  height: 100%;
  display: flex;
  width: 55%;
  margin-left: 15px;
  align-items: center;
  color: #fff;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .dropdown-container .dropdown-info .dropdown-name {
  margin-right: 10px;
  font-weight: 600;
  font-size: 14px;
  overflow: hidden;
  line-height: 20px;
  cursor: pointer;
  letter-spacing: 0.015em;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
  font-style: normal;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .dropdown-container .dropdown-list-container {
  width: 64%;
  display: flex;
  align-items: center;
  letter-spacing: 0.015em;
  margin-top: 40px;
  position: absolute;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .dropdown-container .dropdown-list-container .dropdown-list {
  margin-left: auto;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: 1px 2px 3px -2px rgba(0, 0, 0, 0.75);
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .dropdown-container .dropdown-list-container .dropdown-list .each-option {
  width: 100%;
  cursor: pointer;
  justify-content: center;
  height: 32px;
  align-items: center;
  border-bottom: 1px solid #D9D9D9;
  display: flex;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .dropdown-container .dropdown-list-container .dropdown-list .each-option .each-option-icon {
  height: 19px;
  width: 19px;
  border-radius: 50%;
  margin: 0px 10px 0px 0px;
  position: relative;
  background-color: #D9D9D9;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .dropdown-container .dropdown-list-container .dropdown-list .each-option-label {
  font-size: 11px;
  color: #416080;
  font-weight: 700;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .dropdown-container .dropdown-list-container .dropdown-list .each-option:hover {
  background-color: #e1e2e4;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .ryg-component {
  height: 100%;
  width: 44%;
  display: flex;
  align-items: center;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .rygToggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .rygToggle-container .rygToggle-r {
  background-color: #F93F3F;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .rygToggle-container .rygToggle-y {
  background-color: #FFCD43;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .rygToggle-container .rygToggle-g {
  background-color: #34A853;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .rygToggle-container .rygToggle-b {
  background-color: #0057ff;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .rygToggle-container > div {
  color: #fff;
  width: 22px;
  margin: 1px 5px;
  text-align: center;
  font-size: 10px;
  justify-content: center;
  display: flex;
  border-radius: 50pc;
  padding-top: 1px;
  align-items: center;
  height: 22px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .rygToggle-container > div:hover:not(.r-focus, .y-focus, .g-focus, .b-focus) {
  background-color: #275362;
  color: white;
  cursor: pointer;
  transition: 0.7s;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .rygToggle-container > div.r-focus {
  background-color: #9f7373;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .rygToggle-container > div.y-focus {
  background-color: #a49969;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .rygToggle-container > div.g-focus {
  background-color: #728d59;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .rygToggle-container > div.b-focus {
  background-color: #5e78ab;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list {
  height: calc(53vh - 62px);
  overflow-y: scroll;
  margin-top: 2px;
  margin-bottom: 7px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list .task-item {
  display: flex;
  height: 62px;
  margin: 0px 0px 5px 0px;
  border: 0.5px solid rgba(199, 200, 201, 0.2);
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list .task-item .taskname-container {
  width: 76%;
  flex-direction: column;
  cursor: pointer;
  display: flex;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list .task-item .ryg-status-bar {
  height: 4px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list .task-item .title {
  font-weight: 500;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #000000;
  text-align: left !important;
  font-style: normal;
  margin: 2px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list .task-item .app-name {
  font-style: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  color: #a3a3a7;
  margin: 2px;
  padding-left: 6px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list .task-item .snoozed-till-date {
  font-style: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
  color: #a3a3a7;
  margin: 1px;
  padding-left: 6px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list .task-item .task-item-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  margin: 0px 0.5px;
  background-color: #EFEFEF;
  padding: 8px;
  width: 12%;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list .task-item .fa-chevron-up,
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list .task-item .fa-chevron-down {
  margin-left: 5px;
  margin-right: 5px;
  cursor: pointer;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list::-webkit-scrollbar {
  width: 10px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .notification-task-list::-webkit-scrollbar-thumb {
  background: #9e9e9e;
  border-radius: 10px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .notificationCenter-panel .view-all-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45%;
  height: 32px;
  margin-top: 10px;
  margin: auto;
  font-size: 13px;
  font-weight: 600;
  color: white;
  background-color: #314961;
  border-radius: 15px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 3px;
  z-index: 999;
  height: auto;
  background: #FFFFFF;
  box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 64.8148px 46.8519px rgba(0, 0, 0, 0.0531481), 0px 38.5185px 25.4815px rgba(0, 0, 0, 0.0425185), 0px 20px 13px rgba(0, 0, 0, 0.035), 0px 8.14815px 6.51852px rgba(0, 0, 0, 0.0274815), 0px 1.85185px 3.14815px rgba(0, 0, 0, 0.0168519);
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container {
  animation: 1s ease-out 0s 1 slideInFromLeft;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-header {
  height: 40px;
  width: 100%;
  background: #1F3144;
  display: flex;
  padding: 0px 30px;
  color: white;
  align-items: center;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-header .modal-header-title {
  font-size: 16px;
  font-weight: 600;
  margin-left: 15px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-header .modal-close-icon {
  margin-left: auto;
  cursor: pointer;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-content-container {
  padding: 20px 40px;
  height: auto;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-content-container .modal-content {
  width: 100%;
  height: 100%;
  display: contents;
  border: none;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-content-container .modal-content .snooze-container .k-datepicker {
  height: 35px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-content-container .modal-content .snooze-container .date-picker {
  margin-bottom: 10px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-content-container .modal-content .snooze-container .snooze-label {
  font-size: 13px;
  color: #000000;
  margin-bottom: 10px;
  font-weight: 600;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-content-container .modal-content .snooze-container .snooze-note-container {
  display: flex;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-content-container .modal-content .snooze-container .snooze-note-container .note-sign {
  color: #0777FD;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-content-container .modal-content .snooze-container .snooze-note-container .snooze-note {
  color: #000000;
  letter-spacing: 0.2px;
  font-size: 10px;
  font-weight: 600;
  margin-left: 5px;
  margin-bottom: 15px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-content-container .modal-content .each-function {
  width: 45%;
  height: 100%;
  background: #EAEFF2;
  text-align: center;
  cursor: pointer;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-content-container .modal-content .each-function .label {
  font-size: 13px;
  margin-top: 8px;
  font-weight: 500;
  color: #5A5A5A;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .modal-content-container .modal-content .each-function .sub-label {
  font-size: 11px;
  margin: 5px;
  font-weight: 600;
  color: #5A5A5A;
  text-decoration: underline;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container {
  width: 100%;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .task-name-container {
  height: 40px;
  width: 100%;
  display: flex;
  background-color: #EAEFF2;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .task-name-container .task-name {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  padding: 0px 10px;
  color: #000000;
  display: flex;
  height: 100%;
  align-items: center;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .comment-box-container {
  padding: 15px;
  display: flex;
  width: 100%;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .comment-box-container .comment-box {
  width: 100%;
  height: 70px;
  border: 1px solid rgba(215, 206, 206, 0.3);
  border-radius: 5px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .comment-box-container .comment-box .mentions__control {
  height: 5rem !important;
  background: rgba(136, 136, 136, 0.0901960784) !important;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .comment-box-container .comment-box .mentions {
  width: 100%;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .comment-box-container .comment-box .mentions textarea,
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .comment-box-container .comment-box .mentions .mentions__highlighter {
  letter-spacing: 2px;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .comment-box-container .comment-box .mentions__suggestions {
  z-index: 1000;
  top: 4rem !important;
  width: 60% !important;
  margin-left: 1rem;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .comment-box-container .comment-box .mentions__suggestions__list {
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.15);
  font-size: 10pt;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .comment-box-container .comment-box .mentions__suggestions__item {
  padding: 5px 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .comment-box-container .comment-box .mentions--multiLine {
  height: 100% !important;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .comment-container .comment-box-container .comment-box .mentions__control {
  height: 100% !important;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .button-container {
  display: flex;
  justify-content: end;
  align-items: center;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .button-container .button {
  padding: 8px;
  width: 70px;
  height: 30px;
  font-size: 12px;
  margin-right: 10px;
  color: #ffffff;
  background-color: #0777FD;
  border-radius: 9px;
  letter-spacing: 0.05em;
  font-weight: 700;
  border: none;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .button-container .cancel-button {
  padding: 8px;
  width: 70px;
  font-size: 12px;
  height: 30px;
  margin-right: 10px;
  color: #000000;
  background-color: #F1F3F4;
  border-radius: 9px;
  letter-spacing: 0.05em;
  font-weight: 700;
  border: none;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .success-msg-container {
  height: 55px;
  align-items: center;
  display: flex;
}
.osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel-container .modal-container .modal-inner-container .success-msg-container .success-msg {
  color: #34A853;
  display: flex;
  align-items: center;
  font-weight: 500;
  justify-content: center;
}

.osjs-panel[data-position=bottom] .osjs-panel-item[data-name=globalSearch] .global-search-panel,
.osjs-panel[data-position=bottom] .osjs-panel-item[data-name=notificationCenter] .notificationCenter-panel,
.osjs-panel[data-position=bottom] .osjs-panel-item[data-name=profile] .panel-profile-content {
  bottom: 43px !important;
  top: unset !important;
}

.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-active {
  display: block !important;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-content,
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-panel {
  position: fixed;
  display: none;
  right: 5px;
  border-radius: 5px;
  width: 22em;
  top: 43px;
  padding: 0px 30px;
  background-color: white;
  min-width: 160px;
  z-index: 30000 !important;
  animation: 1s ease-out 0s 1 slideInFromLeft;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-content .profile-info,
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-panel .profile-info {
  font-size: 16px;
  border: none;
  position: relative;
  display: flex;
  flex-direction: row;
  margin: 25px 0px;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-content .profile-info .profile-info-img,
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-panel .profile-info .profile-info-img {
  max-height: 60px;
  max-width: 60px;
  border-radius: 50%;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-content .profile-info .profile-info-content,
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-panel .profile-info .profile-info-content {
  padding: 10px 15px;
  width: 80%;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-content .profile-info .profile-info-content .name,
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-panel .profile-info .profile-info-content .name {
  font-weight: 600;
  cursor: pointer;
  font-size: 18px;
  color: #121414;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-content .profile-info .profile-info-content .designation,
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-panel .profile-info .profile-info-content .designation {
  font-weight: 500;
  font-size: 14px;
  color: #929C9F;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-content .profile-info .profile-info-content .text-overflow,
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-panel .profile-info .profile-info-content .text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-content .profile-actions .action,
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-panel .profile-actions .action {
  margin-bottom: 25px;
  display: flex;
  align-items: center;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-content .profile-actions .action .action-title,
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-panel .profile-actions .action .action-title {
  font-size: 15px;
  font-weight: 500;
  color: #363B3D;
  padding-left: 15px;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-content .profile-actions .action .action-title:hover,
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-panel .profile-actions .action .action-title:hover {
  cursor: pointer;
  text-decoration: underline;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-icon {
  width: 25px;
  height: 25px;
  display: flex;
  background-color: #E9EBEC;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-icon .profile-img {
  cursor: pointer;
  height: 100%;
  border-radius: 50%;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .panel-profile-icon .profile-icon {
  color: #B8BFC1;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-header {
  font-size: 18px;
  font-weight: 600;
  color: #121414;
  text-align: center;
  margin: 18px;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-options {
  height: 150px;
  overflow-y: scroll;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-options .account-option {
  display: flex;
  align-items: center;
  padding: 10px 16px 10px 10px;
  margin-bottom: 5px;
  margin-right: 5px;
  font-weight: 500;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-options .account-option-img {
  width: 50px;
  height: 25px;
  margin-right: 8px;
  object-fit: contain;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-options .account-option:hover {
  background: #F4F5F5;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-options .account-option.selected {
  background: #F4F5F5;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .switch-account-options .account-option-check {
  color: #363B3D;
  margin-left: auto;
  font-size: 16px;
}
.osjs-panel-item[data-name=profile] .osjs-panel-profile .divider {
  border: 1px solid #f0eded;
  margin: 15px 0px;
}

#iconi {
  margin-top: 20px;
  margin-right: 5px;
  margin-bottom: 20px;
  margin-left: 10px;
  color: white;
}

#iconi1 {
  margin-top: 25px;
  margin-right: 5px;
  margin-bottom: 20px;
  margin-left: 10px;
  color: white;
}

#info {
  font-size: 17px;
}

.profileDiv {
  display: flex;
  flex-direction: row;
  line-height: 40px;
}

.profileDiv .icon {
  width: 25%;
  color: white;
  text-align: center;
}

.profileDiv .info {
  font-size: 17px;
  width: 100%;
  color: white;
  text-align: left;
  line-height: 23px;
  word-wrap: word-break;
  margin-top: 8px;
}

.profileCard {
  flex-direction: row;
  color: white;
  padding-top: 10px;
  line-height: 30px;
  padding-bottom: 5px;
}

.profileCard .profileImage {
  text-align: center;
}

.profileName {
  font-size: 18px;
}

.profileButton {
  padding: 5px;
  float: right;
  position: absolute;
  padding-left: 120px;
}

.profileIcon {
  width: 70% !important;
  border-radius: 50%;
}

.profileEdit {
  margin-left: 85px;
}

.coppyRight {
  display: flex;
  align-items: center;
}
.coppyRight #google_translate_element .goog-te-gadget span {
  display: none !important;
}
.coppyRight #google_translate_element .goog-te-gadget {
  font-size: 6px !important;
  margin-left: 10px !important;
}

/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
.osjs-panel-item[data-name=menu] {
  display: contents;
  align-items: center;
  padding: 0;
  cursor: pointer;
}
.osjs-panel-item[data-name=menu] > div {
  padding: 0px 0px !important;
}

.osjs-panel-item[data-name=menu_hidden] {
  display: flex;
  align-items: center;
  padding: 0;
}
.osjs-panel-item[data-name=menu_hidden] > div {
  padding: 0px 5px !important;
}

.appcaption {
  cursor: pointer;
}

.osjs-panel-item[data-name=menu]:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*.osjs-panel-item[data-name=tray] {
  display: flex;
  padding: 0;
  & > div {
    flex: 1 1;
    padding: .5em;
    margin: 4px 1px;

    & > img {
      margin-right: 0;
      vertical-align: middle;
      height: 100%;
      width: auto;
    }
  }
}*/
.osjs-panel-item--icon .badge {
  color: white;
  position: relative;
  right: -22px;
  bottom: -24px;
  top: 18px;
}

@media all {
  .osjs-panel-item[data-name=tray] {
    display: flex;
    padding: 0;
    margin: 0px 8px 0px 0px !important;
  }
  .osjs-panel-item[data-name=tray] > div {
    flex: 1 1;
    padding: 0.5em;
    padding: 2px 4px !important;
    height: 45px;
    width: 45px;
  }
  .osjs-panel-item[data-name=tray] > div > img {
    margin-right: 0;
    vertical-align: middle;
    height: 28px;
    width: auto;
    margin-left: -7px !important;
  }
  .osjs-panel-item[data-name=profile] {
    display: flex;
    width: auto;
    padding: 0px 2px !important;
    margin: 0px 20px 0px 2px;
    align-items: center;
  }
  .osjs-panel-item[data-name=profile] > div > img {
    vertical-align: middle;
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
}
a.profileitem {
  cursor: pointer;
}

@supports (-ms-ime-align: auto) {
  .osjs-panel-item[data-name=tray] {
    display: flex;
    padding: 0;
  }
  .osjs-panel-item[data-name=tray] > div {
    flex: 1 1;
    padding: 0.5em;
    margin: 4px 1px;
    padding: 0px;
    height: 45px;
    width: 45px;
  }
  .osjs-panel-item[data-name=tray] > div > img {
    margin-right: 0;
    vertical-align: middle;
    height: 35px;
    width: auto;
    margin-left: 5px;
  }
  .osjs-panel-item[data-name=profile] {
    display: flex;
    padding: 0;
    width: auto;
  }
  .osjs-panel-item[data-name=profile] > div {
    flex: 1 1;
    margin: 4px 1px;
  }
  .osjs-panel-item[data-name=profile] > div > img {
    margin-right: 0;
    vertical-align: middle;
    height: 100%;
    width: auto;
    border-radius: 50%;
  }
}
@-moz-document url-prefix() {
  .osjs-panel-item[data-name=tray] {
    display: flex;
    padding: 0;
  }
  .osjs-panel-item[data-name=tray] > div {
    flex: 1 1;
    padding: 0.5em;
    margin: 4px 1px;
    padding: 0px;
    height: 45px;
    width: 45px;
  }
  .osjs-panel-item[data-name=tray] > div > img {
    margin-right: 0;
    vertical-align: middle;
    height: 35px;
    width: auto;
    margin-left: 5px;
  }
  .osjs-panel-item[data-name=profile] {
    display: flex;
    padding: 0;
    width: auto;
  }
  .osjs-panel-item[data-name=profile] > div {
    flex: 1 1;
    margin: 4px 1px;
  }
  .osjs-panel-item[data-name=profile] > div > img {
    margin-right: 0;
    vertical-align: middle;
    height: 100%;
    width: 100%;
    border-radius: 50%;
  }
}
.badgeCheck {
  border-radius: 50%;
  background-color: #EE4623;
  font-size: 12px;
  display: inline-block;
  text-align: center;
  position: absolute;
  bottom: 5px;
  z-index: 100;
  height: 14px;
  min-width: 10px;
  line-height: 14px;
}

.osjs-root[data-dir=rtl] .osjs-panel-item[data-name=tray] > div:not(:last-child) {
  margin-right: 0;
  margin-left: 1em;
}

/*.osjs-panel-item[data-name=profile] {
  display: flex;
  padding: 0;
  & > div {
    flex: 1 1;
    margin: 4px 5px;
    & > img {
      margin-right: 0;
      vertical-align: middle;
      height: 100%;
      width: auto;
    }
  }
}*/
.osjs-panel-item {
  padding: 0px !important;
  margin: 0px 8px;
  align-items: center;
}

.osjs-panel-item[data-name=logout] {
  display: flex;
  cursor: pointer;
  height: 30px;
  width: 30px;
  padding: 5px;
  border-radius: 50%;
}
.osjs-panel-item[data-name=logout] > div {
  flex: 1 1;
  padding: 2px;
  font-size: 20px;
  color: white;
}
.osjs-panel-item[data-name=logout] > div > img {
  margin-right: 0;
  vertical-align: middle;
  height: 22px;
  width: 22px;
}

.window-tray-close-button {
  padding: 5px;
  background-color: #275262;
  border-radius: 50%;
  vertical-align: middle;
  display: flex;
  flex-grow: 0.25;
  margin-left: 10px;
}

.osjs-panel-item[data-name=windows] > .window-tray-close-button i {
  width: 7px;
  height: 7px;
}

.window-tray-close-button:hover {
  transition: all 0.5s cubic-bezier(0, 0.105, 0.035, 1.57);
  transform: scale(1.1);
  background-color: #0b242d;
}

img.profile-dropdown-icon {
  width: 25px;
  height: auto;
}

.profile-dropdown-item {
  display: flex;
}

.profile-dropdown-item {
  display: flex;
  padding: 10px;
}

.osjs-panel-item[data-name=tray] > div > img {
  height: 22px;
  padding: 2px;
  width: 22px;
}

.osjs-panel-item[data-name=tray] > div {
  height: 30px;
  width: 30px;
  padding: 0px 0px 0px 2px;
}

.profile-content:before {
  right: 10px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(255, 255, 255, 0);
  border-width: 8px;
  margin-left: -8px;
  pointer-events: auto;
  cursor: pointer;
}

.profile-dropdown-div {
  padding: 0;
  height: auto;
  padding-top: 10px;
  padding-bottom: 10px;
}

/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
.osjs-panel-item[data-name=windows] {
  display: flex;
  flex: 1 1;
  overflow: hidden;
  padding: 0;
}
.osjs-panel-item[data-name=windows] > div {
  cursor: pointer;
  flex: initial;
  padding: 0.6666666667em;
  min-width: 4em;
}
.osjs-panel-item[data-name=windows] > div > span {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.osjs-root[data-dir=rtl] .osjs-panel-item[data-name=windows] > div:not(:last-child) {
  margin-right: 0;
  margin-left: 1em;
}

.swal2-container {
  z-index: 16777275 !important;
}

.spinner {
  width: 50%;
  text-align: center;
}

.spinner > div {
  width: 25px;
  height: 25px;
  background-color: #333;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
  background-color: #ee4623;
}

.spinner .bounce2 {
  margin-right: 3%;
  margin-left: 3%;
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
  background-color: #f4ba18;
}

.spinner .bounce3 {
  background-color: #a3c639;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}
@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/client/packages/panels/index.scss","webpack://./src/client/packages/panels/src/_panel.scss","webpack://./src/client/packages/panels/src/items/_menu.scss","webpack://./src/client/packages/panels/src/items/_tray.scss","webpack://./src/client/packages/panels/src/items/_windows.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;ACAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AAgCA;EACE,yBAAA;AD2BF;;ACxBA;EACE,aAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;AD2BF;ACzBE;EACE,gCAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;AD2BJ;ACEE;EACE,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;ADAJ;ACGE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;ADDJ;ACGI;EACE,WDhEQ;ECiER,mBAAA;ADDN;ACGM;EACE,eAAA;ADDR;ACKI;EACE,2BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;ADHN;ACMI;EACE,yBAAA;EACA,kBAAA;ADJN;;ACSA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,oBAAA;EACA,sCAAA;EACA,oCAAA;EACA,WAAA;ADNF;;ACSA;EACE,WAAA;ADNF;;ACUE;EACE,eAAA;EACA,gBD9GU;AAuGd;;ACWA;EACE,0BAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,iBAAA;EACA,oBAAA;EACA,8BAAA;EACA,gBAAA;ADRF;;ACWA;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;ADRF;;ACWA;EACE,0BAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,4BAAA;EACA,oBAAA;EACA,8BAAA;EACA,gBAAA;ADRF;;ACWA;EACE,YAAA;EACA,aAAA;ADRF;;ACWA,2DAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;ADRF;;ACWA;EACE,YAAA;EACA,QAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;ADRF;ACSE;EACE,UAAA;ADPJ;;ACYA;EACE,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;ADTF;;ACYA;EACE,aAAA;EACA,sBAAA;ADTF;;ACYA;EACE,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,qCAAA;ADTF;;ACYA;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;ADTF;;ACYA;EACE,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;ADTF;;ACYA;EACE,sBAAA;EACA,cArPkB;EAsPlB,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;ADTF;;ACYA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;ADTF;;ACYA;EACE,WAAA;EACA,wDAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gCAAA;EAEA,eAAA;EACA,aAAA;ADVF;;ACaA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kEAAA;EACA,sBAAA;ADVF;;ACaA;EACE,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;ADVF;;ACaA;EACE,6CAAA;EACA,6BAAA;EAEA,iCAAA;ADXF;;ACgBE;EACE,YAAA;ADbJ;ACeI;EACE,yBAAA;ADbN;ACgBI;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;ADdN;ACgBM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;ADdR;ACiBM;EACE,YAAA;EACA,aAAA;EACA,yBAAA;ADfR;ACiBQ;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;ADfV;ACkBQ;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;ADhBV;ACmBQ;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;ADjBV;ACsBI;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;ADpBN;ACuBI;EACE,wBAAA;ADrBN;ACwBI;EACE,aAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,2CAAA;ADtBN;ACwBM;EACE,wBAAA;EACA,WAAA;ADtBR;ACyBU;EACE,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;ADvBZ;ACyBY;EACE,eAAA;EACA,gBAAA;ADvBd;AC2BU;EACE,cAAA;EACA,yBAAA;ADzBZ;AC4BU;EACE,yBAAA;EACA,cAAA;EACA,eAAA;AD1BZ;ACkCY;EACE,yBAAA;ADhCd;ACmCY;EACE,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,wBAAA;EACA,eAAA;ADjCd;ACqCU;EACE,gBAAA;ADnCZ;ACyCM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;ADvCR;AC0CM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ADxCR;AC2CM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ADzCR;AC2CQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;ADzCV;;ACgDA;EACE,aAAA;EACA,mBAAA;AD7CF;AC+CE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;AD7CJ;AC+CI;EACE,eAAA;EACA,cAAA;AD7CN;ACiDE;EACE,yBAAA;AD/CJ;ACkDE;EACE,yBAAA;EACA,eAAA;ADhDJ;;ACoDA;EAKU,uGAAA;EACR,mBAAA;EACA,kCAAA;ADrDF;ACuDE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;ADrDJ;ACuDI;EACE,eAAA;ADrDN;ACwDI;EACE,kBAAA;EACA,yBA3BE;EA4BF,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;ADtDN;AC0DE;EACE;IACE,UAAA;IACA,2BAAA;EDxDJ;EC2DE;IACE,UAAA;IACA,wBAAA;EDzDJ;AACF;AC6DI;EACE,yBAAA;AD3DN;AC8DI;EACE,aAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA;AD5DN;AC8DM;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AD5DR;AC+DM;EACE,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,2BAAA;AD7DR;AC+DQ;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AD7DV;AC+DU;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AD7DZ;ACiEQ;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AD/DV;ACiEU;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gDAAA;AD/DZ;ACiEY;EACE,WAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;AD/Dd;ACiEc;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;AD/DhB;ACmEY;EACE,eAAA;EACA,cAAA;EACA,gBAAA;ADjEd;ACoEY;EACE,yBAAA;ADlEd;ACwEM;EACE,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;ADtER;ACyEM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ADvER;AC0EQ;EACE,yBA1KF;ADkGR;AC2EQ;EACE,yBA7KC;ADoGX;AC4EQ;EACE,yBAhLA;ADsGV;AC6EQ;EACE,yBAnLD;ADwGT;AC+EM;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AD7ER;ACgFM;EACE,yBAhuBY;EAiuBZ,YAAA;EACA,eAAA;EACA,gBAAA;AD9ER;ACiFM;EACE,yBAAA;AD/ER;ACkFM;EACE,yBAAA;ADhFR;ACmFM;EACE,yBAAA;ADjFR;ACoFM;EACE,yBAAA;ADlFR;ACqFM;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;ADnFR;ACqFQ;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,4CAAA;ADnFV;ACqFU;EACE,UAAA;EAEA,sBAAA;EACA,eAAA;EACA,aAAA;ADpFZ;ACuFU;EACE,WAAA;ADrFZ;ACwFU;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;ADtFZ;ACyFU;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;ADvFZ;AC0FU;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;ADxFZ;AC2FU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,UAAA;ADzFZ;AC4FU;;EAEE,gBAAA;EACA,iBAAA;EACA,eAAA;AD1FZ;AC+FM;EACE,WAAA;AD7FR;ACgGM;EACE,mBAAA;EACA,mBAAA;AD9FR;ACiGM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AD/FR;ACmGI;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,0RAAA;ADjGN;ACmGM;EACE,2CAAA;ADjGR;ACmGQ;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;ADjGV;ACmGU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ADjGZ;ACoGU;EACE,iBAAA;EACA,eAAA;ADlGZ;ACsGQ;EACE,kBAAA;EACA,YAAA;ADpGV;ACsGU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;ADpGZ;ACuGc;EACE,YAAA;ADrGhB;ACwGc;EACE,mBAAA;ADtGhB;ACyGc;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;ADvGhB;AC0Gc;EACE,aAAA;ADxGhB;AC0GgB;EACE,cAAA;ADxGlB;AC2GgB;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;ADzGlB;AC8GY;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AD5Gd;AC8Gc;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AD5GhB;AC+Gc;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AD7GhB;ACmHQ;EACE,WAAA;ADjHV;ACmHU;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;ADjHZ;ACmHY;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;ADjHd;ACqHU;EACE,aAAA;EACA,aAAA;EACA,WAAA;ADnHZ;ACqHY;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;ADnHd;ACqHc;EACE,uBAAA;EACA,wDAAA;ADnHhB;ACsHc;EACE,WAAA;ADpHhB;ACsHgB;;EAEE,mBAAA;ADpHlB;ACwHc;EACE,aAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;ADtHhB;ACyHc;EACE,uBAAA;EACA,qCAAA;EACA,eAAA;ADvHhB;AC0Hc;EACE,iBAAA;EACA,4CAAA;ADxHhB;AC2Hc;EACE,uBAAA;ADzHhB;AC4Hc;EACE,uBAAA;AD1HhB;ACgIQ;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;AD9HV;ACgIU;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AD9HZ;ACiIU;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AD/HZ;ACmIQ;EACE,YAAA;EACA,mBAAA;EACA,aAAA;ADjIV;ACmIU;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADjIZ;;ACyIA;;;EAGE,uBAAA;EACA,qBAAA;ADtIF;;AC2II;EACE,yBAAA;ADxIN;AC2II;;EAEE,eAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,2CAAA;EACA,wCAAA;ADzIN;AC2IM;;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;ADxIR;AC0IQ;;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;ADvIV;AC0IQ;;EACE,kBAAA;EACA,UAAA;ADvIV;ACyIU;;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;ADtIZ;ACyIU;;EACE,gBAAA;EACA,eAAA;EACA,cAAA;ADtIZ;ACyIU;;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;ADtIZ;AC4IQ;;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;ADzIV;AC2IU;;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;ADxIZ;AC2IU;;EACE,eAAA;EACA,0BAAA;ADxIZ;AC8II;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AD5IN;AC8IM;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AD5IR;AC+IM;EACE,cAAA;AD7IR;ACiJI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AD/IN;ACkJI;EACE,aAAA;EACA,kBAAA;ADhJN;ACkJM;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,uCAAA;ADhJR;ACmJM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;ADjJR;ACoJM;EACE,mBAAA;ADlJR;ACqJM;EACE,mBAAA;ADnJR;ACsJM;EACE,cAAA;EACA,iBAAA;EACA,eAAA;ADpJR;ACwJI;EACE,yBAAA;EACA,gBAAA;ADtJN;;AC2JA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;ADxJF;;AC2JA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;ADxJF;;AC2JA;EACE,eAAA;ADxJF;;AC2JA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;ADxJF;;AC2JA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;ADxJF;;AC2JA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;ADxJF;;AC2JA;EACE,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;ADxJF;;AC2JA;EACE,kBAAA;ADxJF;;AC2JA;EACE,eAAA;ADxJF;;AC2JA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ADxJF;;AC2JA;EACE,qBAAA;EACA,kBAAA;ADxJF;;AC2JA;EACE,iBAAA;ADxJF;;AC2JA;EACE,aAAA;EACA,mBAAA;ADxJF;AC0JI;EACE,wBAAA;ADxJN;AC2JI;EACE,yBAAA;EACA,4BAAA;ADzJN;;AElsCA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AA8BA;EACE,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;AFosCF;AElsCE;EACE,2BAAA;AFosCJ;;AEhsCA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AFmsCF;AEjsCE;EACE,2BAAA;AFmsCJ;;AE/rCA;EACC,eAAA;AFksCD;;AEhsCA;EACI,0CAAA;AFmsCJ;;AG1vCA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AA8BA;;;;;;;;;;;;;;;EAAA;AAiBA;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;AH2vCF;;AGxvCA;EACE;IACE,aAAA;IACA,UAAA;IACA,kCAAA;EH2vCF;EG1vCE;IACE,SAAA;IACA,cAAA;IACA,2BAAA;IACA,YAAA;IACA,WAAA;EH4vCJ;EG1vCI;IACE,eAAA;IACA,sBAAA;IACA,YAAA;IACA,WAAA;IACA,4BAAA;EH4vCN;EGtvCA;IACE,aAAA;IACA,WAAA;IACA,2BAAA;IACA,wBAAA;IACA,mBAAA;EHwvCF;EGtvCI;IACE,sBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;EHwvCN;AACF;AGpvCA;EACE,eAAA;AHsvCF;;AGnvCA;EACE;IACE,aAAA;IACA,UAAA;EHsvCF;EGrvCE;IACE,SAAA;IACA,cAAA;IACA,eAAA;IACA,YAAA;IACA,YAAA;IACA,WAAA;EHuvCJ;EGrvCI;IACE,eAAA;IACA,sBAAA;IACA,YAAA;IACA,WAAA;IACA,gBAAA;EHuvCN;EGlvCA;IACE,aAAA;IACA,UAAA;IACA,WAAA;EHovCF;EGnvCE;IACE,SAAA;IACA,eAAA;EHqvCJ;EGpvCI;IACE,eAAA;IACA,sBAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;EHsvCN;AACF;AGjvCA;EACE;IACE,aAAA;IACA,UAAA;EHmvCF;EGlvCE;IACE,SAAA;IACA,cAAA;IACA,eAAA;IACA,YAAA;IACA,YAAA;IACA,WAAA;EHovCJ;EGlvCI;IACE,eAAA;IACA,sBAAA;IACA,YAAA;IACA,WAAA;IACA,gBAAA;EHovCN;EG/uCA;IACE,aAAA;IACA,UAAA;IACA,WAAA;EHivCF;EGhvCE;IACE,SAAA;IACA,eAAA;EHkvCJ;EGjvCI;IACE,eAAA;IACA,sBAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;EHmvCN;AACF;AG9uCA;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;EAEA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AH+uCF;;AG1uCE;EACE,eAAA;EACA,gBHvKU;AAo5Cd;;AGzuCA;;;;;;;;;;;;;EAAA;AAcA;EACE,uBAAA;EACA,eAAA;EACA,mBAAA;AH4uCF;;AG1uCA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EAEA,kBAAA;AH4uCF;AG3uCE;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AH6uCJ;AG5uCI;EACE,eAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AH8uCN;;AG1uCA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AH6uCF;;AG3uCA;EACE,UAAA;EACA,WAAA;AH8uCF;;AG5uCA;EACE,wDAAA;EACA,qBAAA;EACA,yBAAA;AH+uCF;;AG7uCA;EACE,WAAA;EACA,YAAA;AHgvCF;;AG9uCA;EACE,aAAA;AHivCF;;AG/uCA;EACE,aAAA;EACA,aAAA;AHkvCF;;AGhvCA;EACE,YAAA;EACA,YAAA;EACA,WAAA;AHmvCF;;AGhvCA;EACE,YAAA;EACA,WAAA;EACA,wBAAA;AHmvCF;;AGjvCA;EACE,WAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,oCAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;AHovCF;;AGlvCA;EACE,UAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AHqvCF;;AIhiDA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AA8BA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;AJkiDF;AIhiDE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;AJkiDJ;AIhiDI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AJkiDN;;AI5hDE;EACE,eAAA;EACA,gBJxBU;AAujDd;;AAhjDA;EACI,4BAAA;AAmjDJ;;AA/iDE;EACE,UAAA;EACA,kBAAA;AAkjDJ;;AA/iDE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gEAAA;EACA,wDAAA;AAkjDJ;;AA/iDE;EACE,+BAAA;EACA,uBAAA;EACA,yBAAA;AAkjDJ;;AA/iDE;EACA,gBAAA;EAEA,eAAA;EAEE,+BAAA;EACA,uBAAA;EACA,yBAAA;AAgjDJ;;AA7iDI;EACA,yBAAA;AAgjDJ;;AA9iDE;EACE;IAAgB,2BAAA;EAkjDlB;EAjjDE;IAAM,2BAAA;EAojDR;AACF;AAljDE;EACE;IACE,2BAAA;IACA,mBAAA;EAojDJ;EAnjDI;IACA,2BAAA;IACA,mBAAA;EAqjDJ;AACF","sourcesContent":["/*!\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n$base-margin: 1em;\n\n@import \"./src/_panel.scss\";\n@import \"./src/items/_menu.scss\";\n@import \"./src/items/_tray.scss\";\n@import \"./src/items/_windows.scss\";\n\n.swal2-container{\n    z-index: 16777275 !important;\n}\n\n\n  .spinner {\n    width: 50%;\n    text-align: center;\n  }\n  \n  .spinner > div {\n    width: 25px;\n    height: 25px;\n    background-color: #333;\n    border-radius: 100%;\n    display: inline-block;\n    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n    animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  }\n  \n  .spinner .bounce1 {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n    background-color: #ee4623;\n  }\n  \n  .spinner .bounce2 {\n  margin-right: 3%;\n\n  margin-left: 3%;\n\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n    background-color: #f4ba18;\n  }\n\n    .spinner .bounce3 {\n    background-color: #a3c639;\n  }\n  @-webkit-keyframes sk-bouncedelay {\n    0%, 80%, 100% { -webkit-transform: scale(0) }\n    40% { -webkit-transform: scale(1.0) }\n  }\n  \n  @keyframes sk-bouncedelay {\n    0%, 80%, 100% { \n      -webkit-transform: scale(0);\n      transform: scale(0);\n    } 40% { \n      -webkit-transform: scale(1.0);\n      transform: scale(1.0);\n    }\n  }","/*\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n$eox-theme-primary: #275362;\n\n.k-animation-container {\n  z-index: 20000 !important;\n}\n\n.osjs-panel {\n  display: flex;\n  height: 2.8em;\n  min-height: 2.8em;\n  align-items: center;\n  box-sizing: border-box;\n  position: absolute;\n  left: 0;\n  right: 0;\n  line-height: normal;\n\n  &[data-ontop=\"true\"] {\n    /* Begin Oxzion customization. */\n    /* z-index: 9995; */\n    z-index: 9995 !important;\n    /* End Oxzion customization. */\n  }\n\n  // &[data-position=\"top\"] {\n  //   top: 0;\n  //   transform: translateY(-94%);\n  //   transition-duration: 0.1s;\n  //   transition-delay: 1s;\n\n  //   &:hover {\n  //     transform: translateY(0);\n  //     transition-duration: 0.2s;\n  //     transition-delay: 0.1s;\n  //   }\n  // }\n\n  // &[data-position=\"bottom\"] {\n  //   bottom: 2em !important;\n  //   transform: translateY(94%);\n  //   transition-duration: 0.1s;\n  //   transition-delay: 1s;\n\n  //   &:hover {\n  //     transform: translateY(0);\n  //     transition-duration: 0.2s;\n  //     transition-delay: 0.1s;\n  //   }\n  // }\n\n  &>.osjs-panel-item {\n    min-height: 1em;\n    position: relative;\n    box-sizing: border-box;\n    padding: calc($base-margin / 1.5);\n    height: 100%;\n  }\n\n  .osjs-panel-item--icon {\n    display: flex;\n    align-items: center;\n    margin: 0px 7px;\n\n    >i {\n      height: $base-margin;\n      margin-right: calc($base-margin / 2);\n\n      >span {\n        font-size: 14px;\n      }\n    }\n\n    .close-icon {\n      margin: 0.1em 0px 0px 0.5em;\n      height: 18px;\n      width: 18px;\n      align-items: center;\n      display: flex;\n      justify-content: center;\n    }\n\n    .close-icon:hover {\n      background-color: #0097C2;\n      border-radius: 50%;\n    }\n  }\n}\n\n.footer-CR {\n  display: flex;\n  min-height: 2.05em;\n  align-items: center;\n  box-sizing: border-box;\n  position: fixed;\n  left: 0;\n  right: 0;\n  line-height: normal;\n  bottom: 0 !important;\n  flex-direction: row-reverse !important;\n  background-color: $eox-theme-primary !important;\n  z-index: 18;\n}\n\n.footer-CR .coppyRight {\n  color: #fff;\n}\n\n.osjs-root[data-dir=\"rtl\"] {\n  .osjs-panel>.osjs-panel-item:not(:last-child) {\n    margin-right: 0;\n    margin-left: $base-margin;\n  }\n}\n\n.profile {\n  height: calc(100% - 3.5em);\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-content: stretch;\n  align-items: stretch;\n  flex-direction: column;\n  width: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  margin-top: 3.5em;\n  margin-bottom: 3.5em;\n  background-color: rgb(0, 0, 1);\n  transition: 0.5s;\n}\n\n.profile-visible {\n  width: 300px;\n  z-index: 16777271;\n  padding-left: 7px;\n}\n\n.appmenu {\n  height: calc(100% - 4.5em);\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-content: stretch;\n  align-items: stretch;\n  flex-direction: column;\n  width: 0;\n  position: absolute;\n  top: 0;\n  margin-top: 2.5em !important;\n  margin-bottom: 3.5em;\n  background-color: rgb(0, 0, 1);\n  transition: 0.5s;\n}\n\n.appmenu-visible {\n  width: 300px;\n  z-index: 9994;\n}\n\n/* Position and style the close button (top right corner) */\n.appmenu .closebtn {\n  position: absolute;\n  top: 0;\n  right: 25px;\n  font-size: 48px;\n  margin-left: 50px;\n}\n\n.appmenu .app-bar {\n  flex-grow: 1;\n  order: 4;\n  padding-right: 0;\n  box-sizing: border-box;\n  position: relative;\n  align-self: auto;\n  padding-bottom: 0;\n  padding-left: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n}\n\n\n.appmenu .app-bar .category {\n  box-sizing: border-box;\n  order: 0;\n  min-height: 48px;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 0 10px;\n}\n\n.appmenu .app-bar .applist {\n  display: flex;\n  flex-direction: column;\n}\n\n.appmenu .app-bar .category .caption {\n  box-sizing: border-box;\n  text-align: left;\n  padding-left: 0px;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  align-self: stretch;\n  padding: 10px;\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n.appmenu .app-bar .app {\n  margin: 5px 10px;\n  flex-direction: unset;\n  min-height: 48px;\n  max-width: unset;\n  display: flex;\n}\n\n.appmenu .app-bar .app .icon {\n  box-sizing: border-box;\n  position: relative;\n  max-width: 48px;\n  min-width: 48px;\n  font-size: 25px;\n  height: 48px;\n  color: #fff !important;\n  height: 48px;\n  line-height: 48px !important;\n  text-align: center;\n  background-size: 45px;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  cursor: inherit !important;\n}\n\n.appmenu .app-bar .app .appcaption {\n  box-sizing: border-box;\n  color: $eox-theme-primary;\n  font-size: 16px;\n  line-height: 48px;\n  display: inline-block;\n  padding-left: 14px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.appmenu .app-search-div {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  border: 0px solid transparent;\n  order: 3;\n  flex: 0 1 auto;\n  align-self: auto;\n  flex-shrink: 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n.appmenu .app-search-bar-div {\n  width: 100%;\n  transition: all 0.5s cubic-bezier(0, 0.105, 0.035, 1.57);\n  overflow: hidden;\n  background: white !important;\n  position: relative;\n  transition: all 0.3s ease-in-out;\n  // background: white;\n  padding: 0 15px;\n  display: flex;\n}\n\n.appmenu .app-search-div input {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-shadow: none;\n  width: 100%;\n  height: 48px;\n  position: relative;\n  top: 0;\n  left: 0;\n  background: 0 0;\n  box-sizing: border-box;\n  border: 0;\n  outline: 0;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #265160;\n  padding: 0 10px;\n  transition: all 0.3s cubic-bezier(0.39, 0.58, 0.57, 1), padding 0s;\n  transition-delay: 0.3s;\n}\n\n.appmenu .app-bar .applist .app i {\n  background-repeat: no-repeat;\n  box-sizing: border-box;\n  position: relative;\n  max-width: 48px;\n  min-width: 48px;\n  font-size: 25px;\n  display: flex;\n  color: #265160 !important;\n  height: 48px;\n  line-height: 48px !important;\n  text-align: center;\n  background-size: 30px;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  cursor: inherit !important;\n}\n\n.appmenu .app-bar .app:hover {\n  background: #ffffff4d;\n  transition: all 200ms ease-in;\n  // transform: scale(1.1);\n  background-size: cover !important;\n  // background-color: transparent !important;\n}\n\n.osjs-panel-item[data-name=\"globalSearch\"] {\n  .osjs-panel-global-serach {\n    height: 100%;\n\n    .panel-active {\n      display: block !important;\n    }\n\n    .global-search-bar-container {\n      display: flex;\n      color: white;\n      justify-content: center;\n      align-items: center;\n      height: 100%;\n      position: relative;\n\n      i {\n        font-size: 19px;\n        margin-left: 5px;\n        cursor: pointer;\n      }\n\n      .global-search-bar {\n        width: 320px;\n        display: none;\n        z-index: 30000 !important;\n\n        .input-search-icon {\n          font-size: 11px;\n          position: absolute;\n          left: 10px;\n          top: 16px !important;\n          color: #314961;\n        }\n\n        .input-clear-icon {\n          font-size: 12px;\n          position: absolute;\n          right: 15px;\n          top: 16px !important;\n          color: #314961;\n        }\n\n        .search-bar {\n          width: 100%;\n          color: #000000;\n          height: 30px;\n          font-size: 13px;\n          background-color: #EAEFF2;\n          border-radius: 50px;\n          outline: none;\n          border: 1px solid #2375F5;\n          padding: 0px 38px;\n        }\n      }\n    }\n\n    .search-icon {\n      height: 30px;\n      display: flex;\n      width: 30px;\n      padding: 0px;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .search-icon-inactive {\n      display: none !important;\n    }\n\n    .global-search-panel {\n      display: none;\n      z-index: 30000 !important;\n      position: fixed;\n      width: 24em;\n      top: 43px;\n      color: #000000;\n      padding: 15px;\n      border-radius: 5px;\n      min-height: 150px;\n      background-color: #EAEFF2;\n      animation: 1s ease-out 0s 1 slideInFromLeft;\n\n      .search-filters {\n        padding: 0px 0px 0px 5px;\n        width: 100%;\n\n        .filter-option-container {\n          .filter-option {\n            display: inline-grid;\n            text-align: center;\n            width: 31%;\n            padding: 3px 11px;\n            border-width: 2px;\n            border-style: solid;\n            border-color: rgb(7, 119, 253);\n            border-image: initial;\n            margin: 10px 3px;\n            border-radius: 3px;\n            color: #0777FD;\n            background-color: #F6F8FA;\n\n            .option-name {\n              font-size: 12px;\n              font-weight: 500;\n            }\n          }\n\n          .focus {\n            color: #FFFFFF;\n            background-color: #314961;\n          }\n\n          .filter-option:hover {\n            background-color: #314961;\n            color: #FFFFFF;\n            cursor: pointer;\n          }\n        }\n\n        .recent-searched-container {\n\n          .recent-searched {\n\n            .label-focus {\n              color: #000000 !important;\n            }\n\n            .data-name {\n              font-size: 12px;\n              display: inline-grid;\n              font-weight: 600;\n              text-align: left;\n              color: #0777FD;\n              margin: 6px 12px 6px 0px;\n              cursor: pointer;\n            }\n          }\n\n          .margin-top {\n            margin-top: 10px;\n          }\n        }\n\n      }\n\n      .error-msg {\n        color: #F93F3F;\n        font-size: 13px;\n        font-weight: 500;\n        margin-bottom: 10px;\n      }\n\n      .search-label {\n        color: #000000;\n        font-size: 13px;\n        font-weight: 600;\n      }\n\n      .search-button-container {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        .search-button {\n          color: #0777FD;\n          font-size: 13px;\n          font-weight: 600;\n          text-align: center;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n\n.osjs-panel-item[data-name=\"myHome\"] {\n  display: flex;\n  align-items: center;\n\n  .osjs-panel-my-home {\n    height: 70%;\n    align-items: center;\n    display: flex;\n    padding: 0px 12px;\n    border-radius: 10px;\n\n    .icon {\n      font-size: 16px;\n      color: #ffffff;\n    }\n  }\n\n  .panel-active {\n    background-color: #007698;\n  }\n\n  .osjs-panel-my-home:hover {\n    background-color: #007698;\n    cursor: pointer;\n  }\n}\n\n.osjs-panel-item[data-name=\"notificationCenter\"] {\n  $red: #F93F3F;\n  $yellow: #FFCD43;\n  $green: #34A853;\n  $blue: #0057ff;\n  @import url(\"https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap\");\n  align-items: center;\n  margin: 0px 0px 0px 8px !important;\n\n  .osjs-panel-notificationCenter {\n    display: flex;\n    height: 100%;\n    flex-direction: row;\n    font-size: 15px;\n    color: white;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n    font-weight: 700;\n    cursor: pointer;\n    position: relative;\n\n    i {\n      font-size: 20px;\n    }\n\n    .notificationCenter-badge {\n      border-radius: 50%;\n      background-color: $red;\n      font-size: 12px;\n      text-align: center;\n      min-width: 19px;\n      position: relative;\n      line-height: 14px;\n      bottom: 7px;\n      padding: 2px;\n      right: 6px;\n    }\n  }\n\n  @keyframes slideInFromLeft {\n    0% {\n      opacity: 0;\n      transform: translateY(-5px);\n    }\n\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  .notificationCenter-panel-container {\n    .panel-active {\n      display: block !important;\n    }\n\n    .notificationCenter-panel {\n      display: none;\n      z-index: 30000 !important;\n      position: fixed;\n      width: 22em;\n      top: 42px;\n      right: 4em;\n      height: 58vh;\n      background-color: #ffffff;\n      border-radius: 5px;\n      animation: 1s ease-out 0s 1 slideInFromLeft;\n\n      .tasks-completed {\n        height: calc(58vh - 82px);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        text-align: center;\n        font-size: 18px;\n        font-weight: 600;\n      }\n\n      .dropdown-container {\n        background-color: #416080;\n        font-weight: 600;\n        height: 40px;\n        display: flex;\n        border-top-right-radius: 5px;\n        border-top-left-radius: 5px;\n\n        .dropdown-info {\n          height: 100%;\n          display: flex;\n          width: 55%;\n          margin-left: 15px;\n          align-items: center;\n          color: #fff;\n\n          .dropdown-name {\n            margin-right: 10px;\n            font-weight: 600;\n            font-size: 14px;\n            overflow: hidden;\n            line-height: 20px;\n            cursor: pointer;\n            letter-spacing: 0.015em;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            color: #fff;\n            font-style: normal;\n          }\n        }\n\n        .dropdown-list-container {\n          width: 64%;\n          display: flex;\n          align-items: center;\n          letter-spacing: 0.015em;\n          margin-top: 40px;\n          position: absolute;\n\n          .dropdown-list {\n            margin-left: auto;\n            width: 100%;\n            height: 100%;\n            background-color: #fff;\n            box-shadow: 1px 2px 3px -2px rgba(0, 0, 0, 0.75);\n\n            .each-option {\n              width: 100%;\n              cursor: pointer;\n              justify-content: center;\n              height: 32px;\n              align-items: center;\n              border-bottom: 1px solid #D9D9D9;\n              display: flex;\n\n              .each-option-icon {\n                height: 19px;\n                width: 19px;\n                border-radius: 50%;\n                margin: 0px 10px 0px 0px;\n                position: relative;\n                background-color: #D9D9D9;\n              }\n            }\n\n            .each-option-label {\n              font-size: 11px;\n              color: #416080;\n              font-weight: 700;\n            }\n\n            .each-option:hover {\n              background-color: #e1e2e4;\n            }\n          }\n        }\n      }\n\n      .ryg-component {\n        height: 100%;\n        width: 44%;\n        display: flex;\n        align-items: center;\n      }\n\n      .rygToggle-container {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n\n        .rygToggle-r {\n          background-color: $red;\n        }\n\n        .rygToggle-y {\n          background-color: $yellow;\n        }\n\n        .rygToggle-g {\n          background-color: $green;\n        }\n\n        .rygToggle-b {\n          background-color: $blue;\n        }\n      }\n\n      .rygToggle-container>div {\n        color: #fff;\n        width: 22px;\n        margin: 1px 5px;\n        text-align: center;\n        font-size: 10px;\n        justify-content: center;\n        display: flex;\n        border-radius: 50pc;\n        padding-top: 1px;\n        align-items: center;\n        height: 22px;\n      }\n\n      .rygToggle-container>div:hover:not(.r-focus, .y-focus, .g-focus, .b-focus) {\n        background-color: $eox-theme-primary;\n        color: white;\n        cursor: pointer;\n        transition: 0.7s;\n      }\n\n      .rygToggle-container>div.r-focus {\n        background-color: #9f7373;\n      }\n\n      .rygToggle-container>div.y-focus {\n        background-color: #a49969\n      }\n\n      .rygToggle-container>div.g-focus {\n        background-color: #728d59;\n      }\n\n      .rygToggle-container>div.b-focus {\n        background-color: #5e78ab;\n      }\n\n      .notification-task-list {\n        height: calc(53vh - 62px);\n        overflow-y: scroll;\n        margin-top: 2px;\n        margin-bottom: 7px;\n\n        .task-item {\n          display: flex;\n          height: 62px;\n          margin: 0px 0px 5px 0px;\n          border: 0.5px solid rgba(199, 200, 201, 0.2);\n\n          .taskname-container {\n            width: 76%;\n            // max-width: 220px;\n            flex-direction: column;\n            cursor: pointer;\n            display: flex;\n          }\n\n          .ryg-status-bar {\n            height: 4px;\n          }\n\n          .title {\n            font-weight: 500;\n            font-size: 13px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            color: #000000;\n            text-align: left !important;\n            font-style: normal;\n            margin: 2px;\n          }\n\n          .app-name {\n            font-style: normal;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            font-size: 12px;\n            font-weight: 500;\n            text-align: left;\n            color: #a3a3a7;\n            margin: 2px;\n            padding-left: 6px;\n          }\n\n          .snoozed-till-date {\n            font-style: normal;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            font-size: 11px;\n            font-weight: 500;\n            text-align: left;\n            color: #a3a3a7;\n            margin: 1px;\n            padding-left: 6px;\n          }\n\n          .task-item-actions {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 15px;\n            margin: 0px 0.5px;\n            background-color: #EFEFEF;\n            padding: 8px;\n            width: 12%;\n          }\n\n          .fa-chevron-up,\n          .fa-chevron-down {\n            margin-left: 5px;\n            margin-right: 5px;\n            cursor: pointer;\n          }\n        }\n      }\n\n      .notification-task-list::-webkit-scrollbar {\n        width: 10px;\n      }\n\n      .notification-task-list::-webkit-scrollbar-thumb {\n        background: #9e9e9e;\n        border-radius: 10px;\n      }\n\n      .view-all-button {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 45%;\n        height: 32px;\n        margin-top: 10px;\n        margin: auto;\n        font-size: 13px;\n        font-weight: 600;\n        color: white;\n        background-color: #314961;\n        border-radius: 15px;\n      }\n    }\n\n    .modal-container {\n      position: fixed;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      border-radius: 3px;\n      z-index: 999;\n      height: auto;\n      background: #FFFFFF;\n      box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 64.8148px 46.8519px rgba(0, 0, 0, 0.0531481), 0px 38.5185px 25.4815px rgba(0, 0, 0, 0.0425185), 0px 20px 13px rgba(0, 0, 0, 0.035), 0px 8.14815px 6.51852px rgba(0, 0, 0, 0.0274815), 0px 1.85185px 3.14815px rgba(0, 0, 0, 0.0168519);\n\n      .modal-inner-container {\n        animation: 1s ease-out 0s 1 slideInFromLeft;\n\n        .modal-header {\n          height: 40px;\n          width: 100%;\n          background: #1F3144;\n          display: flex;\n          padding: 0px 30px;\n          color: white;\n          align-items: center;\n\n          .modal-header-title {\n            font-size: 16px;\n            font-weight: 600;\n            margin-left: 15px;\n          }\n\n          .modal-close-icon {\n            margin-left: auto;\n            cursor: pointer;\n          }\n        }\n\n        .modal-content-container {\n          padding: 20px 40px;\n          height: auto;\n\n          .modal-content {\n            width: 100%;\n            height: 100%;\n            display: contents;\n            border: none;\n\n            .snooze-container {\n              .k-datepicker {\n                height: 35px;\n              }\n\n              .date-picker {\n                margin-bottom: 10px;\n              }\n\n              .snooze-label {\n                font-size: 13px;\n                color: #000000;\n                margin-bottom: 10px;\n                font-weight: 600;\n              }\n\n              .snooze-note-container {\n                display: flex;\n\n                .note-sign {\n                  color: #0777FD;\n                }\n\n                .snooze-note {\n                  color: #000000;\n                  letter-spacing: 0.2px;\n                  font-size: 10px;\n                  font-weight: 600;\n                  margin-left: 5px;\n                  margin-bottom: 15px;\n                }\n              }\n            }\n\n            .each-function {\n              width: 45%;\n              height: 100%;\n              background: #EAEFF2;\n              text-align: center;\n              cursor: pointer;\n\n              .label {\n                font-size: 13px;\n                margin-top: 8px;\n                font-weight: 500;\n                color: #5A5A5A;\n              }\n\n              .sub-label {\n                font-size: 11px;\n                margin: 5px;\n                font-weight: 600;\n                color: #5A5A5A;\n                text-decoration: underline;\n              }\n            }\n          }\n        }\n\n        .comment-container {\n          width: 100%;\n\n          .task-name-container {\n            height: 40px;\n            width: 100%;\n            display: flex;\n            background-color: #EAEFF2;\n\n            .task-name {\n              width: 100%;\n              font-size: 14px;\n              font-weight: 700;\n              padding: 0px 10px;\n              color: #000000;\n              display: flex;\n              height: 100%;\n              align-items: center;\n            }\n          }\n\n          .comment-box-container {\n            padding: 15px;\n            display: flex;\n            width: 100%;\n\n            .comment-box {\n              width: 100%;\n              height: 70px;\n              border: 1px solid rgba(215, 206, 206, 0.3);\n              border-radius: 5px;\n\n              .mentions__control {\n                height: 5rem !important;\n                background: #88888817 !important;\n              }\n\n              .mentions {\n                width: 100%;\n\n                textarea,\n                .mentions__highlighter {\n                  letter-spacing: 2px;\n                }\n              }\n\n              .mentions__suggestions {\n                z-index: 1000;\n                top: 4rem !important;\n                width: 60% !important;\n                margin-left: 1rem;\n              }\n\n              .mentions__suggestions__list {\n                background-color: white;\n                border: 1px solid rgba(0, 0, 0, 0.15);\n                font-size: 10pt;\n              }\n\n              .mentions__suggestions__item {\n                padding: 5px 15px;\n                border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n              }\n\n              .mentions--multiLine {\n                height: 100% !important;\n              }\n\n              .mentions__control {\n                height: 100% !important;\n              }\n            }\n          }\n        }\n\n        .button-container {\n          display: flex;\n          justify-content: end;\n          align-items: center;\n\n          .button {\n            padding: 8px;\n            width: 70px;\n            height: 30px;\n            font-size: 12px;\n            margin-right: 10px;\n            color: #ffffff;\n            background-color: #0777FD;\n            border-radius: 9px;\n            letter-spacing: 0.05em;\n            font-weight: 700;\n            border: none;\n          }\n\n          .cancel-button {\n            padding: 8px;\n            width: 70px;\n            font-size: 12px;\n            height: 30px;\n            margin-right: 10px;\n            color: #000000;\n            background-color: #F1F3F4;\n            border-radius: 9px;\n            letter-spacing: 0.05em;\n            font-weight: 700;\n            border: none;\n          }\n        }\n\n        .success-msg-container {\n          height: 55px;\n          align-items: center;\n          display: flex;\n\n          .success-msg {\n            color: #34A853;\n            display: flex;\n            align-items: center;\n            font-weight: 500;\n            justify-content: center;\n          }\n        }\n      }\n    }\n  }\n}\n\n.osjs-panel[data-position=\"bottom\"] .osjs-panel-item[data-name=\"globalSearch\"] .global-search-panel,\n.osjs-panel[data-position=\"bottom\"] .osjs-panel-item[data-name=\"notificationCenter\"] .notificationCenter-panel,\n.osjs-panel[data-position=\"bottom\"] .osjs-panel-item[data-name=\"profile\"] .panel-profile-content {\n  bottom: 43px !important;\n  top: unset !important;\n}\n\n.osjs-panel-item[data-name=\"profile\"] {\n  .osjs-panel-profile {\n    .panel-active {\n      display: block !important;\n    }\n\n    .panel-profile-content,\n    .switch-account-panel {\n      position: fixed;\n      display: none;\n      right: 5px;\n      border-radius: 5px;\n      width: 22em;\n      top: 43px;\n      padding: 0px 30px;\n      background-color: white;\n      min-width: 160px;\n      z-index: 30000 !important;\n      animation: 1s ease-out 0s 1 slideInFromLeft;\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n\n      .profile-info {\n        font-size: 16px;\n        border: none;\n        position: relative;\n        display: flex;\n        flex-direction: row;\n        margin: 25px 0px;\n\n        .profile-info-img {\n          max-height: 60px;\n          max-width: 60px;\n          border-radius: 50%;\n        }\n\n        .profile-info-content {\n          padding: 10px 15px;\n          width: 80%;\n\n          .name {\n            font-weight: 600;\n            cursor: pointer;\n            font-size: 18px;\n            color: #121414;\n          }\n\n          .designation {\n            font-weight: 500;\n            font-size: 14px;\n            color: #929C9F;\n          }\n\n          .text-overflow {\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n          }\n        }\n      }\n\n      .profile-actions {\n        .action {\n          margin-bottom: 25px;\n          display: flex;\n          align-items: center;\n\n          .action-title {\n            font-size: 15px;\n            font-weight: 500;\n            color: #363B3D;\n            padding-left: 15px;\n          }\n\n          .action-title:hover {\n            cursor: pointer;\n            text-decoration: underline;\n          }\n        }\n      }\n    }\n\n    .panel-profile-icon {\n      width: 25px;\n      height: 25px;\n      display: flex;\n      background-color: #E9EBEC;\n      border-radius: 50%;\n      align-items: center;\n      justify-content: center;\n\n      .profile-img {\n        cursor: pointer;\n        height: 100%;\n        border-radius: 50%;\n      }\n\n      .profile-icon {\n        color: #B8BFC1;\n      }\n    }\n\n    .switch-account-header {\n      font-size: 18px;\n      font-weight: 600;\n      color: #121414;\n      text-align: center;\n      margin: 18px;\n    }\n    \n    .switch-account-options {\n      height: 150px;\n      overflow-y: scroll;\n\n      .account-option {\n        display: flex;\n        align-items: center;\n        padding: 10px 16px 10px 10px;\n        margin-bottom: 5px;\n        margin-right: 5px;\n        font-weight: 500;\n        border-radius: 5px;\n        cursor: pointer;\n        transition: background 0.3s ease-in-out;\n      }\n\n      .account-option-img {\n        width: 50px;\n        height: 25px;\n        margin-right: 8px;\n        object-fit: contain;\n      }\n\n      .account-option:hover {\n        background: #F4F5F5;\n      }\n\n      .account-option.selected {\n        background: #F4F5F5;\n      }\n\n      .account-option-check {\n        color: #363B3D;\n        margin-left: auto;\n        font-size: 16px;\n      }\n    }\n\n    .divider {\n      border: 1px solid #f0eded;\n      margin: 15px 0px;\n    }\n  }\n}\n\n#iconi {\n  margin-top: 20px;\n  margin-right: 5px;\n  margin-bottom: 20px;\n  margin-left: 10px;\n  color: white;\n}\n\n#iconi1 {\n  margin-top: 25px;\n  margin-right: 5px;\n  margin-bottom: 20px;\n  margin-left: 10px;\n  color: white;\n}\n\n#info {\n  font-size: 17px;\n}\n\n.profileDiv {\n  display: flex;\n  flex-direction: row;\n  line-height: 40px;\n}\n\n.profileDiv .icon {\n  width: 25%;\n  color: white;\n  text-align: center;\n}\n\n.profileDiv .info {\n  font-size: 17px;\n  width: 100%;\n  color: white;\n  text-align: left;\n  line-height: 23px;\n  word-wrap: word-break;\n  margin-top: 8px;\n}\n\n.profileCard {\n  flex-direction: row;\n  color: white;\n  padding-top: 10px;\n  line-height: 30px;\n  padding-bottom: 5px;\n}\n\n.profileCard .profileImage {\n  text-align: center;\n}\n\n.profileName {\n  font-size: 18px;\n}\n\n.profileButton {\n  padding: 5px;\n  float: right;\n  position: absolute;\n  padding-left: 120px;\n}\n\n.profileIcon {\n  width: 70% !important;\n  border-radius: 50%;\n}\n\n.profileEdit {\n  margin-left: 85px;\n}\n\n.coppyRight {\n  display: flex;\n  align-items: center;\n  #google_translate_element {\n    .goog-te-gadget span {\n      display: none !important;\n    }\n\n    .goog-te-gadget {\n      font-size: 6px !important;\n      margin-left: 10px !important;\n    }\n  }\n}","/*\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n.osjs-panel-item[data-name=menu] {\n  display: contents;\n  align-items: center;\n  padding: 0;\n  cursor:pointer;\n\n  & > div {\n    padding: 0px 0px !important;\n  }\n}\n\n.osjs-panel-item[data-name=menu_hidden] {\n  display: flex;\n  align-items: center;\n  padding: 0;\n\n  & > div {\n    padding: 0px 5px !important;\n  }\n}\n\n.appcaption{\n\tcursor:pointer;\n}\n.osjs-panel-item[data-name=menu]:hover{\n    background-color: rgba(255, 255, 255, 0.4);\n}","/*\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n/*.osjs-panel-item[data-name=tray] {\n  display: flex;\n  padding: 0;\n  & > div {\n    flex: 1 1;\n    padding: .5em;\n    margin: 4px 1px;\n\n    & > img {\n      margin-right: 0;\n      vertical-align: middle;\n      height: 100%;\n      width: auto;\n    }\n  }\n}*/\n\n.osjs-panel-item--icon .badge {\n  color: white;\n  position: relative;\n  right: -22px;\n  bottom: -24px;\n  top: 18px;\n}\n\n@media all {\n  .osjs-panel-item[data-name=\"tray\"] {\n    display: flex;\n    padding: 0;\n    margin: 0px 8px 0px 0px !important;\n    & > div {\n      flex: 1 1;\n      padding: 0.5em;\n      padding: 2px 4px !important;\n      height: 45px;\n      width: 45px;\n\n      & > img {\n        margin-right: 0;\n        vertical-align: middle;\n        height: 28px;\n        width: auto;\n        margin-left: -7px !important;\n        // margin-left: 9px;\n      }\n    }\n  }\n\n  .osjs-panel-item[data-name=\"profile\"] {\n    display: flex;\n    width: auto;\n    padding: 0px 2px !important;\n    margin: 0px 20px 0px 2px;\n    align-items: center;\n    & > div {\n      & > img {\n        vertical-align: middle;\n        width: 24px;\n        height: 24px;\n        border-radius: 50%;\n      }\n    }\n  }\n}\na.profileitem {\n  cursor: pointer;\n}\n\n@supports (-ms-ime-align: auto) {\n  .osjs-panel-item[data-name=\"tray\"] {\n    display: flex;\n    padding: 0;\n    & > div {\n      flex: 1 1;\n      padding: 0.5em;\n      margin: 4px 1px;\n      padding: 0px;\n      height: 45px;\n      width: 45px;\n\n      & > img {\n        margin-right: 0;\n        vertical-align: middle;\n        height: 35px;\n        width: auto;\n        margin-left: 5px;\n      }\n    }\n  }\n\n  .osjs-panel-item[data-name=\"profile\"] {\n    display: flex;\n    padding: 0;\n    width: auto;\n    & > div {\n      flex: 1 1;\n      margin: 4px 1px;\n      & > img {\n        margin-right: 0;\n        vertical-align: middle;\n        height: 100%;\n        width: auto;\n        border-radius: 50%;\n      }\n    }\n  }\n}\n\n@-moz-document url-prefix() {\n  .osjs-panel-item[data-name=\"tray\"] {\n    display: flex;\n    padding: 0;\n    & > div {\n      flex: 1 1;\n      padding: 0.5em;\n      margin: 4px 1px;\n      padding: 0px;\n      height: 45px;\n      width: 45px;\n\n      & > img {\n        margin-right: 0;\n        vertical-align: middle;\n        height: 35px;\n        width: auto;\n        margin-left: 5px;\n      }\n    }\n  }\n\n  .osjs-panel-item[data-name=\"profile\"] {\n    display: flex;\n    padding: 0;\n    width: auto;\n    & > div {\n      flex: 1 1;\n      margin: 4px 1px;\n      & > img {\n        margin-right: 0;\n        vertical-align: middle;\n        height: 100%;\n        width: 100%;\n        border-radius: 50%;\n      }\n    }\n  }\n}\n\n.badgeCheck {\n  border-radius: 50%;\n  background-color: #EE4623;\n  font-size: 12px;\n  // padding: 3px;\n  display: inline-block;\n  text-align: center;\n  position: absolute;\n  bottom: 5px;\n  z-index: 100;\n  height: 14px;\n  min-width: 10px;\n  line-height: 14px;\n  // padding: 0 3px;\n}\n\n.osjs-root[data-dir=\"rtl\"] {\n  .osjs-panel-item[data-name=\"tray\"] > div:not(:last-child) {\n    margin-right: 0;\n    margin-left: $base-margin;\n  }\n}\n\n/*.osjs-panel-item[data-name=profile] {\n  display: flex;\n  padding: 0;\n  & > div {\n    flex: 1 1;\n    margin: 4px 5px;\n    & > img {\n      margin-right: 0;\n      vertical-align: middle;\n      height: 100%;\n      width: auto;\n    }\n  }\n}*/\n.osjs-panel-item {\n  padding: 0px !important;\n  margin: 0px 8px;\n  align-items: center;\n}\n.osjs-panel-item[data-name=\"logout\"] {\n  display: flex;\n  cursor: pointer;\n  height: 30px;\n  width: 30px;\n  padding: 5px;\n  // margin: 4px 1px;\n  border-radius: 50%;\n  & > div {\n    flex: 1 1;\n    padding: 2px;\n    font-size: 20px;\n    color: white;\n    & > img {\n      margin-right: 0;\n      vertical-align: middle;\n      height: 22px;\n      width: 22px;\n    }\n  }\n}\n.window-tray-close-button {\n  padding: 5px;\n  background-color: #275262;\n  border-radius: 50%;\n  vertical-align: middle;\n  display: flex;\n  flex-grow: 0.25;\n  margin-left: 10px;\n}\n.osjs-panel-item[data-name=\"windows\"] > .window-tray-close-button i {\n  width: 7px;\n  height: 7px;\n}\n.window-tray-close-button:hover {\n  transition: all 0.5s cubic-bezier(0, 0.105, 0.035, 1.57);\n  transform: scale(1.1);\n  background-color: #0b242d;\n}\nimg.profile-dropdown-icon {\n  width: 25px;\n  height: auto;\n}\n.profile-dropdown-item {\n  display: flex;\n}\n.profile-dropdown-item {\n  display: flex;\n  padding: 10px;\n}\n.osjs-panel-item[data-name=\"tray\"] > div > img {\n  height: 22px;\n  padding: 2px;\n  width: 22px;\n}\n\n.osjs-panel-item[data-name=\"tray\"] > div {\n  height: 30px;\n  width: 30px;\n  padding: 0px 0px 0px 2px;\n}\n.profile-content:before {\n  right: 10px;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n  border-color: rgba(255, 255, 255, 0);\n  border-width: 8px;\n  margin-left: -8px;\n  pointer-events: auto;\n  cursor: pointer;\n}\n.profile-dropdown-div {\n  padding: 0;\n  height: auto;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n","/*\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n.osjs-panel-item[data-name=windows] {\n  display: flex;\n  flex: 1 1;\n  overflow: hidden;\n  padding: 0;\n\n  & > div {\n    cursor: pointer;\n    flex: initial;\n    padding: calc($base-margin / 1.5);\n    min-width: 4em;\n\n    & > span {\n      display: block;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n  }\n}\n\n.osjs-root[data-dir=\"rtl\"] {\n  .osjs-panel-item[data-name=windows] > div:not(:last-child) {\n    margin-right: 0;\n    margin-left: $base-margin;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
